import { useContext } from "react"
import { Radio, RadioGroup } from "@headlessui/react"
import { CheckCircleIcon, StopIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function Layout() {
  const { queryString, setQueryString, layout, setLayout } = useContext(MultiContext)
  const layouts = [
    { layout: 1, name: "Single" },
    { layout: 4, name: "Grid - 2x2" },
    { layout: 9, name: "Grid - 3x3" },
    { layout: 3, name: "3 up" },
    { layout: 6, name: "6 up" },
    { layout: 7, name: "7 up" },
  ]

  const clickHandler = (value) => {
    setLayout(value)
    setQueryString({ ...queryString, layout: value })
  }

  return (
    <Panel>
      <Panel.Buttons>
        <RadioGroup
          value={layout}
          onChange={clickHandler}
          aria-label="Server size"
          className="grid flex-1 grid-flow-row grid-cols-3 grid-rows-2 gap-2"
        >
          {layouts.map(({ layout, name }) => (
            <Radio
              key={layout}
              value={layout}
              className="data-[checked]:bg-bg-gray-800/10 group relative flex cursor-pointer rounded-lg bg-gray-900/10 p-2 text-gray-800 transition hover:bg-gray-600/10 focus:outline-none"
            >
              <div className="flex w-full items-center sm:justify-center">
                <CheckCircleIcon className="size-6 stroke-gray-700 opacity-0 transition group-data-[checked]:opacity-100 sm:absolute sm:left-0 sm:ml-2" />
                <div className="text-sm/6">{name}</div>
              </div>
            </Radio>
          ))}
        </RadioGroup>
      </Panel.Buttons>
      <Panel.Layout Icon={StopIcon} enabledOptions="none" />
    </Panel>
  )
}
